import React from "react";
import { useNavigate } from "react-router-dom";
import { FaBus, FaTaxi, FaWheelchair, FaAmbulance } from "react-icons/fa";
import { MdFlight } from "react-icons/md";
import { TbSteeringWheel } from "react-icons/tb";

const PROJECTS = [
  {
    id: "school",
    label: "School/Education",
    icon: <FaBus size={28} />,
    route: "/dashboard",
    comingSoon: false,
  },
  {
    id: "rideshare",
    label: "Taxi/Rideshare",
    icon: <FaTaxi size={28} />,
    route: "/rideshare/dashboard",
    comingSoon: false,
  },
  {
    id: "limo",
    label: "Limo/Charter",
    icon: <TbSteeringWheel size={28} />,
    route: null,
    comingSoon: true,
  },
  {
    id: "airport",
    label: "Airport Transfer",
    icon: <MdFlight size={28} />,
    route: null,
    comingSoon: true,
  },
  {
    id: "paratransit",
    label: "ParaTransit",
    icon: <FaWheelchair size={28} />,
    route: null,
    comingSoon: true,
  },
  {
    id: "ems",
    label: "EMS",
    icon: <FaAmbulance size={28} />,
    route: null,
    comingSoon: true,
  },
];

const ProjectSwitcher = ({ activeProject }) => {
  const navigate = useNavigate();

  const handleSelect = (project) => {
    if (project.comingSoon || !project.route) return;
    localStorage.setItem("activeProject", project.id);
    navigate(project.route);
  };

  return (
    <div className="project-switcher-wrapper mb-4">
      <p className="project-switcher-label">ACTIVE VERSION</p>
      <div className="project-switcher-grid">
        {PROJECTS.map((project) => {
          const isActive = project.id === activeProject;
          return (
            <div
              key={project.id}
              className={`project-card ${isActive ? "active" : ""} ${project.comingSoon ? "disabled" : ""}`}
              onClick={() => handleSelect(project)}
            >
              <span className="project-card-icon">{project.icon}</span>
              <span className="project-card-name">{project.label}</span>
              {project.comingSoon && (
                <span className="project-card-soon">coming soon</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProjectSwitcher;
